import { Injectable } from '@angular/core';
import { HammerGestureConfig } from '@angular/platform-browser';

import * as hammer from 'hammerjs';

@Injectable()
export class CustomHammerConfig extends HammerGestureConfig {
	overrides = {
		tap: { taps: 1 },
		pan: { direction: hammer.DIRECTION_HORIZONTAL },
		swipe: { direction: hammer.DIRECTION_HORIZONTAL },
	};
}
